import Form from './Form'

interface TuneOption {
  id: number
  name: string
}

interface Props {
  set: {
    id: number
    name: string
    tune_ids: number[]
  }
  tunes: TuneOption[]
  errors?: Record<string, string | string[]>
}

export default function Edit({ set, tunes, errors }: Props) {
  return (
    <Form
      heading="Edit set"
      title={`Edit ${set.name}`}
      submitLabel="Save set"
      action={`/sets/${set.id}`}
      method="patch"
      tunes={tunes}
      initialName={set.name}
      initialTuneIds={set.tune_ids}
      errors={errors}
    />
  )
}
